import { Stories } from 'store/records/stories'
import * as types from './actionTypes'
import { fromJS, Map } from 'immutable'
import { deleteStoryApiRequest, updateStoryApiRequest } from 'store/entities/feed/actions'
import * as feedTypes from 'store/entities/feed/actionTypes'

export const initialState = new Stories()

const setProTracks = (state, payload) => {
  return state.set('proTracks', fromJS(payload.data.protracks))
}

const setStories = (state, payload) => {
  const stories = fromJS(payload.data.data)
  return state
    .setIn(['pending', 'getStories'], false)
    .setIn(['loaded', 'getStories'], true)
    .set('stories', stories)
    .set('storiesPagination', new Map(payload.data.pagination))
}

const setStoriesLoadMore = (state, payload) => {
  const newStories = fromJS(payload.data.data)
  const stories = state.get('stories').concat(newStories)
  return state
    .setIn(['pending', 'getStoriesLoadMore'], false)
    .setIn(['loaded', 'getStoriesLoadMore'], !newStories.size)
    .set('stories', stories)
    .set('storiesPagination', new Map(payload.data.pagination))
}

const updateStoryFromSocket = (state, payload) => {
  const {
    activityUserStory: { id, story },
  } = payload
  const findStoryIndex = state.get('stories').findIndex(el => el.get('id') === id)
  if (findStoryIndex !== -1) {
    state = state.setIn(['stories', findStoryIndex, 'story'], story)
  }

  return state
}

const updateStory = (state, payload) => {
  const { id, story } = payload.data
  const findStoryIndex = state.get('stories').findIndex(el => el.get('id') === id)
  if (findStoryIndex !== -1) {
    state = state.setIn(['stories', findStoryIndex, 'story'], story)
  }
  return state
}

const deleteStory = (state, { storyId }) => {
  const findStoryIndex = state.get('stories').findIndex(el => el.get('id') === storyId)
  if (findStoryIndex !== -1) {
    state = state.set('stories', state.get('stories').delete(findStoryIndex))
  }

  return state
}

const storiesReducer = (state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case types.STORIES_ENABLE_PENDING: {
      return state.setIn(['pending', 'getStories'], true)
    }
    case types.STORIES_ENABLE_LOAD_MORE_PENDING: {
      return state.setIn(['pending', 'getStoriesLoadMore'], true)
    }
    case types.STORIES_GET_PROTRACKS.GET.SUCCESS: {
      return setProTracks(state, payload)
    }
    case types.STORIES.GET.SUCCESS: {
      return setStories(state, payload)
    }
    case types.STORIES_LOAD_MORE.GET.SUCCESS: {
      return setStoriesLoadMore(state, payload)
    }
    case deleteStoryApiRequest.success.toString(): {
      return deleteStory(state, payload)
    }
    case feedTypes.FEED_UPDATE_STORY_FROM_SOCKETS: {
      return updateStoryFromSocket(state, payload)
    }
    case updateStoryApiRequest.success.toString(): {
      return updateStory(state, payload)
    }
    default:
      return state
  }
}

export default storiesReducer
